/* eslint-disable */
// This script is copy-pasta from Pendo
function startPendo(
  userData = {},
  userRole,
  nextivaCXFreeTrialAttributes,
  skipAdministration,
  hasCXChatFeature,
  licenseFeatures,
) {
  (function (apiKey) {
    (function (p, e, n, d, o) {
      var v, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = [];
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
      for (w = 0, x = v.length; w < x; ++w)
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? 'unshift' : 'push'](
                [m].concat([].slice.call(arguments, 0)),
              );
            };
        })(v[w]);
      y = e.createElement(n);
      y.async = !0;
      y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
  })('d4612175-6792-4105-58ca-25657df236e3');

  pendo.initialize({
    visitor: {
      id: userData?.loginId,
      full_name: `${userData?.firstName} ${userData?.lastName}`,
      email: userData?.email,
      userRole,
      userLevelSkipAdministration: skipAdministration,
      hasCXChatFeature,
      licenseFeatures,
    },
    account: {
      id: window.location.hostname,
      corpAccountNumber: userData.profileDTO?.corpAcctNbr,
      ...nextivaCXFreeTrialAttributes,
      ...(userData.accountInfo ?? {}),
      userLevelSkipAdministration: skipAdministration,
    },
  });
}

export { startPendo };
